import { QueryClient, DefaultOptions } from '@tanstack/react-query';

const queryConfig: DefaultOptions = {
  queries: {
    staleTime: 5 * 60 * 1000, // 5 minutos (padrão para home)
    cacheTime: 30 * 60 * 1000, // 30 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 1,
    retryDelay: (attemptIndex: number) =>
      Math.min(1000 * Math.pow(2, attemptIndex), 30000),
  },
  mutations: {
    retry: 1,
    retryDelay: (attemptIndex: number) =>
      Math.min(1000 * Math.pow(2, attemptIndex), 30000),
  },
};


export function createQueryClient(): QueryClient {
  return new QueryClient({ defaultOptions: queryConfig });
}

export const defaultQueryClient = createQueryClient();
